import type { FaireProductEntity } from "../../entity_types/product";

export const p_brttmh7em4: FaireProductEntity = {
  token: "p_brttmh7em4",
  type: "product",
  name: "Gold or Silver CZ Snowman Figure Christmas Charm CPG2922",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/833bf00885fe97744af0c04cc5a634ca55ba5a496729db3774a49799fd4e7fa3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d23983bbaf90bd61ffaada3710aaae0e5bac31e1081ee113611ac63edd14c422.jpeg",
    "https://cdn.faire.com/fastly/e6274b3236e0fe857a3b9d122b2ad91d6a9563aced64ff94c21d14f5e7cfdccd.jpeg",
    "https://cdn.faire.com/fastly/774a7c46d09ee67cec4b522495d7a395db72ea69ab70b7e551eb52194bec5ab8.jpeg",
    "https://cdn.faire.com/fastly/135ade1ad461afe0e746036d240f73fbab3cb99f1dbe80a893c6ce4fe2ebafcd.jpeg",
    "https://cdn.faire.com/fastly/95f62d9c8b4f73848ad3f4dd9830438d76f85c7f853acf452fa7f15e49db1fef.jpeg",
    "https://cdn.faire.com/fastly/d64da5119032fc005fd7026e995e29faf6b36ce995676945a9010efe6ea239a8.jpeg",
  ],
  priceDollars: 6.48,
  description:
    "Gold or Silver Snowman Charm, Small full Figure Snowman Charm, Christmas charm, Xmas Charms, Cute Snowman Charm, CPG2922-CPS2922\n\nListing is for one piece only\nChain is not included\n\nMaterial: 14K Gold Plating Over Brass,E-Coated Tarnish Free\nMeasurement: 14mm x 10mm\nOpen Jump Ring:2.8\nStones: Cubic Zirconia\nThickness:2.0mm\nAll measurements are approximate\n\nLead, Cadmium and nickel free\n\nShips From Los Angeles",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:57.619Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
